import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

import { useModalShareTaxInformationWithPayers } from "../../../../../../shared/components/ModalShareTaxInformationWithPayers/useModalShareTaxInformationWithPayers";
import { getRequirementDefinitionTableCellProps } from "../../../../../RequirementDefinitions/utils";
import {
  CellsConfig,
  ContextItem,
  RequirementAction,
  RequirementTableCallback
} from "../../../../types";
import { TaxVerificationAdditionalData } from "../../types";
import { getTaxVerificationRequirementName } from "../helpers/getTaxVerificationRequirementName";
import { getTaxVerificationRequirementPayerStatusCell } from "../helpers/getTaxVerificationRequirementPayerStatusCell";

export const usePayerTaxVerificationConfig = (
  _: RequirementTableCallback
): CellsConfig<
  PayeeRequirement,
  ContextItem,
  TaxVerificationAdditionalData
> => {
  const modalFormW9Consent = useModalShareTaxInformationWithPayers();

  return {
    isActionRequired: () => false,

    requirementName: getTaxVerificationRequirementName,

    nameCell: requirement => ({
      text: getTaxVerificationRequirementName(requirement)
    }),

    typeCell: requirement =>
      getRequirementDefinitionTableCellProps({
        type: requirement.type!
      }),

    statusCell: getTaxVerificationRequirementPayerStatusCell,

    toolbarActions: (requirement, context, dataSource) => {
      const actions: RequirementAction[] = [];

      // `dataSourceMetadata` is an untyped backend-owned blob (no SDK schema);
      // `shareTaxDocument` is compared against its raw wire value.
      const taxDocumentSharePermission = requirement.dataSourceMetadata
        ?.payeeOwnedData?.shareTaxDocument as string | undefined;

      if (
        context.hideTaxVerificationConsent !== true &&
        taxDocumentSharePermission !== "Allow"
      ) {
        actions.push({
          label: "Consent to share information",
          icon: "clipboard-check",
          onClick: () => {
            modalFormW9Consent.open({
              payerId: requirement.payerAccountId
            });
          }
        });
      }

      return actions;
    }
  };
};
